import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSession } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const fetchSessionsByRoomSystem = async (
  orgId: string,
  roomSystemId: string,
  date?: string,
): Promise<PublicSession[]> => {
  const response = await axiosClient.get(
    `${orgId}/sessions/room-system/${roomSystemId}`,
    {
      params: {
        date,
      },
    },
  );
  return response.data;
};

export function fetchSessionsByRoomSystemQueryKey({
  orgId,
  roomSystemId,
  date,
}: {
  orgId: string;
  roomSystemId: string;
  date?: string;
}) {
  return ["session", orgId, roomSystemId, date];
}

export function useFetchSessionsByRoomSystem(
  roomSystemId: string,
  date?: string,
  queryOptions?: Partial<UseQueryOptions<PublicSession[], HttpError>>,
) {
  const { organisation } = useOrganisation();
  return useQuery({
    queryKey: fetchSessionsByRoomSystemQueryKey({
      orgId: organisation.id,
      roomSystemId,
      date,
    }),
    queryFn: () =>
      fetchSessionsByRoomSystem(organisation.id, roomSystemId, date),
    ...queryOptions,
  });
}
